import React from 'react';
import { observer } from "mobx-react";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContentText from '@material-ui/core/DialogContentText';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import ApiClient from "utils/ApiClient";
import styled, { css } from "styled-components";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import DeleteIcon from '@material-ui/icons/Delete';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Select from '@material-ui/core/Select';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from "@material-ui/core/CircularProgress";
import FileCopyIcon from '@material-ui/icons/FileCopy';
import Backdrop from '@material-ui/core/Backdrop';


const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
        //   <Box p={3}>
            <Typography>{children}</Typography>
        //   </Box>
        )}
      </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
}
  
const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper,
    },
    table: {
        minWidth: 650,
    },
    formUser: {
        minWidth: 400,
    },
    formName: {
        minWidth: 383,
    },
    formApiKey: {
        minWidth: 350
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);


function ApiKeys(props) {

  const classes = useStyles();
  const [isLoading, setIsLoading] = React.useState(false);
  const [value, setValue] = React.useState(0);
  const [apiKeysData, setApiKeysData] = React.useState([]);
  const [apiKeyRequests, setApiKeyRequests] = React.useState([]);
  const [openPopper, setOpenPopper] = React.useState(false);
  const [openRequestForm, setOpenRequestForm] = React.useState(false);
  const [description, setDescription] = React.useState('');
  const [users, setUsers] = React.useState([]);
  const [name, setName] = React.useState('');
  const [selectedUser, setSelectedUser] = React.useState(null);
  const [isErrorResp, setIsErrorResp] = React.useState(false);
  const [newApiResp, setNewApiResp] = React.useState(null);
  const [isApiKeyCreating, setIsApiKeyCreating] = React.useState(false);
  const [apiKeyDeletingId, setApiKeyDeletingId] = React.useState(false);
  const [apiKeyShowingId, setApiKeyShowingId] = React.useState(null);

  const [apiKeyRequestDeletingId, setApiKeyRequestDeletingId] = React.useState(null);
  const [apiKeyRequestApprovedId, setApiKeyRequestApprovedId] = React.useState(null);
  const [isApiKeyRequesting, setIsApiKeyRequesting] = React.useState(false);
  const [oneTimeViewAPIKey, setOneTimeViewAPIKey] = React.useState(null);
  

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const fetchUserApiKeys = async () => {
    let resp = await ApiClient.Account.getUserApiKeys();
    setApiKeysData(resp.data);
  }

  const fetchActiveUsers = async () => {
    let resp = await ApiClient.Account.getActiveUsers();
    setUsers(resp.data);
  }

  const fetchApiKeyRequests = async () => {
    let resp = await ApiClient.Account.getApiKeyRequests();
    setApiKeyRequests(resp.data);
  }

  const fetchApiKeysData = async () => {
    await Promise.all([fetchUserApiKeys(),fetchActiveUsers(), fetchApiKeyRequests()]);
  }

  const createUserApiKey = async () => {
    let resp = await ApiClient.Account.createUserApiKey({
        "name": name,
        "userId": selectedUser.id
    });
    if (resp.data) {
        window.appStore.notificationStore.showNotification(
            "Api key has been created successfully",
            "success"
        );
        setNewApiResp(resp.data);
        if(apiKeyRequestApprovedId) {
            let apiKeyRequestResp = await ApiClient.Account.updateApiKeyRequestStatus({
                "id": apiKeyRequestApprovedId,
                "status": 'approved'
            });
            if(apiKeyRequestResp.success) {
                let tempApiKeyRequests = apiKeyRequests.slice();
                tempApiKeyRequests = tempApiKeyRequests.filter((request) => request.id != apiKeyRequestApprovedId);
                setApiKeyRequests(tempApiKeyRequests);
            }
            setApiKeyRequestApprovedId(null);
        }
        await fetchUserApiKeys();
    }
  }

  const deleteApiKey = async (id) => {
    let resp = await ApiClient.Account.deleteApiKey({
        "id": id
    });
    if (resp.success) {
        window.appStore.notificationStore.showNotification(
            "Api key has been deleted successfully",
            "success"
        );
        let tempApiKeysData = apiKeysData.slice();
        tempApiKeysData = tempApiKeysData.filter((apikey) => apikey.id != id);
        setApiKeysData(tempApiKeysData);
    }
  }

  const handleDeclineApiKeyRequest = async (id) => {
    let resp = await ApiClient.Account.updateApiKeyRequestStatus({
        "id": id,
        "status": 'declined'
    });
    if (resp.success) {
        window.appStore.notificationStore.showNotification(
            "This Request has been declined!",
            "success"
        );
        let tempApiKeyRequests = apiKeyRequests.slice();
        tempApiKeyRequests = tempApiKeyRequests.filter((request) => request.id != id);
        setApiKeyRequests(tempApiKeyRequests);
    }
  }

  const handleApproveApiKeyRequest = async (requestData) => {
    setOpenPopper(true);
    let approvedUser = users.filter((user) => user.id == requestData.user_id)[0]
    setSelectedUser(approvedUser);
    setApiKeyRequestApprovedId(requestData.id);
  }

  const requestApiKey = async () => {
    let resp = await ApiClient.Account.requestApiKey({
        "description": description
    });
    if (resp.success) {
        window.appStore.notificationStore.showNotification(
            "An Api key request has been made successfully to the Admin.",
            "success"
        );
        setOpenRequestForm(false);
        setDescription("");
        if(resp.data) {
            setApiKeyRequests([...apiKeyRequests, resp.data]);
        }
    }
  }

  const handleViewApiKeyOnce = async (keyId) => {
    let resp = await ApiClient.Account.handleViewApiKeyOnce({
        "id": keyId
    });
    if (resp.success && resp.data.success) {
        let tempApiKeysData = apiKeysData.slice();
        let tempApiKeysData2 = [];
        tempApiKeysData.forEach((apiKey) => {
            if(apiKey.id == keyId) {
                apiKey.is_viewed_once = 1;
            }
            tempApiKeysData2.push(apiKey);
        });
        setApiKeysData(tempApiKeysData2);
        setOneTimeViewAPIKey(resp.data.api_key);
    }
  }

  React.useEffect(()=> {
    async function fetchData() {
        setIsLoading(true);
        await fetchApiKeysData();
        setIsLoading(false);
    }
    fetchData();
  },[]);
  
  let usersMap = {};
  users.forEach((user) => {
    usersMap[user.id] = user.email;
  });

  return (
    <>
    { isLoading ? 
        <Backdrop className={classes.backdrop} open={isLoading}>
            <CircularProgress color="inherit" />
        </Backdrop>
      :
      <Dialog 
        maxWidth={"lg"} 
        onClose={props.handleDialogClose} 
        aria-labelledby="customized-dialog-title" 
        open={props.openDialog} 
        PaperProps={{
          style: {
            minWidth: '800px',
            minHeight: '400px'
          },
        }}>        
            {props.packStore.appStore.userStore.user.isAdminForUsers ? 
                <>
                    <DialogTitle style={{paddingBottom: 0}}>
                        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" indicatorColor="primary">
                            <Tab label="Api Keys" {...a11yProps(0)} />
                            <Tab label="Key Requests" {...a11yProps(1)} />
                        </Tabs>
                    </DialogTitle>
                    <DialogContent>
                        <TabPanel value={value} index={0}>
                            {apiKeysData.length > 0 ?
                                <TableContainer>
                                    <Table className={classes.table} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Name</TableCell>
                                                <TableCell align="right">Key</TableCell>
                                                <TableCell align="right">User</TableCell>
                                                <TableCell align="right">Created</TableCell>
                                                <TableCell align="right">Last Used</TableCell>
                                                {props.packStore.appStore.userStore.user.isAdminForUsers &&
                                                    <>
                                                        <TableCell align="right"></TableCell>
                                                        <TableCell align="right"></TableCell>
                                                    </>
                                                }
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                        {apiKeysData.length > 0 && apiKeysData.map((row, index) => (
                                            <TableRow key={index}>
                                                <TableCell component="th" scope="row">
                                                    {row.name}
                                                </TableCell>
                                                <TableCell align="right">{row.api_key}</TableCell>
                                                <TableCell align="right">{usersMap[row.user_id]}</TableCell>
                                                <TableCell align="right">{row.created_at}</TableCell>
                                                <TableCell align="right">{row.last_used_at == "0000-00-00 00:00:00" ? "Never": row.last_used_at}</TableCell>
                                                {props.packStore.appStore.userStore.user.isAdminForUsers &&
                                                    <>
                                                    <TableCell align="right">
                                                        <IconButton 
                                                            size ="small"
                                                            onClick={async () => {
                                                                await window.appStore.notificationStore.confirm({
                                                                    description: <>This action will permanently delete this API key</>,
                                                                });
                                                                setApiKeyDeletingId(row.id);
                                                                await deleteApiKey(row.id);
                                                                setApiKeyDeletingId(row.id);
                                                            }}
                                                        >
                                                            <DeleteIcon style={{color: "red"}}/>
                                                        </IconButton> 
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        {apiKeyDeletingId == row.id &&
                                                            <CircularProgress style={{width: 15, height: 15, color: "red"}} />
                                                        }
                                                    </TableCell>
                                                    </>
                                                }
                                            </TableRow>
                                        ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            : <Typography>{"No API Keys. Create your API Key below."}</Typography>
                            }
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            {apiKeyRequests.length > 0 ?
                                <TableContainer>
                                    <Table className={classes.table} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>User</TableCell>
                                                <TableCell align="right">Description</TableCell>
                                                <TableCell align="right">Requested On</TableCell>
                                                <TableCell align="right"></TableCell>
                                                <TableCell align="right"></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {apiKeyRequests.length > 0 && apiKeyRequests.map((request, index) => (
                                                <TableRow key={index}>
                                                <TableCell component="th" scope="row">
                                                    {usersMap[request.user_id]}
                                                </TableCell>
                                                <TableCell align="right">{request.description}</TableCell>
                                                <TableCell align="right">{request.created_at}</TableCell>
                                                <TableCell align="right">
                                                    <Button 
                                                        autoFocus 
                                                        onClick={()=>{
                                                            handleApproveApiKeyRequest(request);
                                                        }} 
                                                        style={{color: "green"}}
                                                    >
                                                        Approve
                                                    </Button>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <Button 
                                                        autoFocus 
                                                        onClick={async()=>{
                                                            setApiKeyRequestDeletingId(request.id)
                                                            await handleDeclineApiKeyRequest(request.id);
                                                            setApiKeyRequestDeletingId(null);
                                                        }} 
                                                        style={{color: "red"}}
                                                    >
                                                        Decline {apiKeyRequestDeletingId == request.id && <CircularProgress style={{width: 15, height: 15, marginLeft: 5, color: "red"}} />}
                                                    </Button>
                                                </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            : <Typography>{"No API Key Requests"}</Typography>
                            }
                        </TabPanel>
                    </DialogContent>
                </>
            :   
                <>
                    <DialogTitle style={{paddingBottom: 0}}>
                        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" indicatorColor="primary">
                            <Tab label="Api Keys" {...a11yProps(0)} />
                            <Tab label="Key Requests" {...a11yProps(1)} />
                        </Tabs>
                    </DialogTitle>
                    <DialogContent>
                        <TabPanel value={value} index={0}>
                            {apiKeysData.length > 0 ?
                                <TableContainer>
                                    <Table className={classes.table} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Name</TableCell>
                                                <TableCell align="right">Key</TableCell>
                                                <TableCell align="right">User</TableCell>
                                                <TableCell align="right">Created</TableCell>
                                                <TableCell align="right">Last Used</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                        {apiKeysData.length > 0 && apiKeysData.map((row, index) => (
                                            <TableRow key={index}>
                                            <TableCell component="th" scope="row">
                                                {row.name}
                                            </TableCell>
                                            <TableCell align="right">{row.api_key}</TableCell>
                                            <TableCell align="right">{usersMap[row.user_id]}</TableCell>
                                            <TableCell align="right">{row.created_at}</TableCell>
                                            <TableCell align="right">{row.last_used_at == "0000-00-00 00:00:00" ? "Never": row.last_used_at}</TableCell>
                                            {row.is_viewed_once == 0 &&
                                                <TableCell align="right">
                                                    <Button 
                                                        autoFocus 
                                                        onClick={async()=>{
                                                            setApiKeyShowingId(row.id);
                                                            await handleViewApiKeyOnce(row.id);
                                                            setApiKeyShowingId(null);
                                                        }}
                                                        color='primary'
                                                    >
                                                        View Key {apiKeyShowingId == row.id && <CircularProgress color='inherit' style={{width: 15, height: 15, marginLeft: 5}} />}
                                                    </Button>
                                                </TableCell>
                                            }
                                            </TableRow>
                                        ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            : <Typography> {"No API Keys. Request for an API Key below."} </Typography>}
                        </TabPanel>

                        <TabPanel value={value} index={1}>
                            {apiKeyRequests.length > 0 ? 
                                <TableContainer>
                                    <Table className={classes.table} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>User</TableCell>
                                                <TableCell align="right">Description</TableCell>
                                                <TableCell align="right">Requested On</TableCell>
                                                <TableCell align='right'>Status</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {apiKeyRequests.length > 0 && apiKeyRequests.map((request, index) => (
                                                <TableRow key={index}>
                                                    <TableCell component="th" scope="row">
                                                        {usersMap[request.user_id]}
                                                    </TableCell>
                                                    <TableCell align="right">{request.description}</TableCell>
                                                    <TableCell align="right">{request.created_at}</TableCell>
                                                    <TableCell 
                                                        align='right' 
                                                        style={{
                                                            color : request.status == 'approved'? 'green' : (request.status == 'declined' ? "red": "#d6a215") 
                                                        }}
                                                    >
                                                        {request.status}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            : <Typography>{"No API Key Requests"}</Typography>
                            }
                        </TabPanel>

                    </DialogContent>
                </>
            }
            <DialogActions style={{ justifyContent: value == 0 && "space-between" }}>
                {(value == 0 && props.packStore.appStore.userStore.user.isAdminForUsers) &&
                    <Button 
                        onClick={async()=>{
                            setOpenPopper(true);
                        }} 
                        style={{
                            marginLeft: 20
                        }}
                        color="primary"
                    >
                        {"+ Create new api key"}
                    </Button>
                }
                {(value == 0 && !props.packStore.appStore.userStore.user.isAdminForUsers) &&
                    <Button 
                        onClick={async()=>{
                            setOpenRequestForm(true);
                        }} 
                        style={{
                            marginLeft: 20
                        }}
                        color="primary"
                    >
                        {"Request new api key"}
                    </Button>
                }
                <Button autoFocus onClick={props.handleDialogClose} color="primary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    }

    <Dialog
        open={openPopper}
        maxWidth={"xs"}
        onClose={()=> {
            setOpenPopper(false);
            setNewApiResp(null);
            setName("");
            setSelectedUser(null);
            setApiKeyRequestApprovedId(null);
            setIsErrorResp(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <DialogTitle id="alert-dialog-title">{"Create New Api key"}</DialogTitle>
        <DialogContent>
            {newApiResp ?
                <>
                    <DialogContentText>
                        {"Please save this api key safe and accessible. You won't be able to view it again in Tigersheet. If you lose this api key, you can generate a new one."}
                    </DialogContentText>
                    <FormControl className={classes.formApiKey}>
                        <TextField
                            autoFocus
                            fullWidth
                            margin="dense"
                            id="name"
                            value={newApiResp.api_key}
                            variant={"outlined"}
                        />
                    </FormControl>
                    <FormControl>
                        <IconButton 
                            style={{marginLeft: 5}} 
                            aria-label="close" 
                            className={classes.closeButton}
                            onClick={()=>{
                                navigator.clipboard.writeText(newApiResp.api_key);
                                window.appStore.notificationStore.showNotification(
                                    "Api key copied successfully",
                                    "success"
                                );
                            }}
                        >
                            <FileCopyIcon style={{color: "#237ff4"}}/>
                        </IconButton>
                    </FormControl>
                </>
            :
                <>
                    <FormControl className={classes.formName}>
                        <FormLabel>Name</FormLabel>
                        <TextField
                            id="outlined-full-width"
                            placeholder="Test api key"
                            fullWidth
                            margin="normal"
                            value={name}
                            onChange={(e)=>{
                                setName(e.target.value)
                                if(selectedUser != null) {
                                    setIsErrorResp(false);
                                }
                            }}
                            style={{
                                marginLeft: 15
                            }}
                        />
                    </FormControl>
                    <FormControl className={classes.formUser}>
                        <FormLabel>Select user</FormLabel>
                        {/* <Select
                            labelId="demo-dialog-select-label"
                            id="demo-dialog-select"
                            value={selectedUser ? selectedUser : ""}
                            onChange={(e)=>{
                                setSelectedUser(e.target.value)
                                if (name != "") {
                                    setIsErrorResp(false);
                                }
                            }}
                            input={<Input />}
                            style={{
                                marginLeft: 15
                            }}
                        >
                            {users.length > 0 && users.map((user, index) => (
                                <MenuItem key={index} value={user}>{user.email}</MenuItem>
                            ))}
                        </Select> */}

                        <Autocomplete
                            id="combo-box-demo"
                            options={users}
                            getOptionLabel={(option) => option.email}
                            style={{ marginTop: 5, marginLeft: 15 }}
                            value={selectedUser ? selectedUser: ""}
                            onChange={(event, newValue)=>{
                                setSelectedUser(newValue);
                                if (name != "") {
                                    setIsErrorResp(false);
                                }
                            }}
                            renderInput={(params) => <TextField {...params} />}
                        />
                    </FormControl>
                    {isErrorResp &&
                        <FormControl className={classes.formUser}>
                            <FormLabel style={{color: "red"}}>{"Please fill all the required fields."}</FormLabel>
                        </FormControl>
                    }
                </>
            }
        </DialogContent>
        <DialogActions>
            <Button 
                onClick={()=> {
                    setOpenPopper(false);
                    setNewApiResp(null);
                    setName("");
                    setSelectedUser(null);
                    setApiKeyRequestApprovedId(null);
                    setIsErrorResp(false);
                }} 
                color="primary"
            >
                {newApiResp ? "Close": "Cancel"}
            </Button>
            {!newApiResp &&
                <Button 
                    onClick={async()=> {
                        if (name == "" || selectedUser == null) {
                            setIsErrorResp(true);
                            return;
                        }
                        setIsApiKeyCreating(true)
                        await createUserApiKey();
                        setIsApiKeyCreating(false);
                    }} 
                    color="primary" 
                    autoFocus
                >
                    Create {isApiKeyCreating && <CircularProgress style={{width: 15, height: 15, marginLeft: 5}} />}
                </Button>
            }
        </DialogActions>
    </Dialog>


    <Dialog
        open={openRequestForm}
        maxWidth={"xs"}
        onClose={()=> {
            setOpenRequestForm(false);
            setDescription("");
            setIsErrorResp(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <DialogTitle id="alert-dialog-title">{"Request New Api key"}</DialogTitle>
        <Typography variant="body2" style={{marginLeft: 16, color: 'grey'}} gutterBottom>
            This request will be made to the admin and he can approve it.
        </Typography>
        <DialogContent>
            <FormControl className={classes.formName}>
                <FormLabel>Description</FormLabel>
                <TextField
                    id="outlined-full-width"
                    placeholder="Provide description"
                    fullWidth
                    margin="normal"
                    value={description}
                    onChange={(e)=>{
                        setDescription(e.target.value);
                        setIsErrorResp(false);
                    }}
                    style={{
                        marginLeft: 15,
                        width: '95%'
                    }}
                />
            </FormControl>
            {isErrorResp &&
                <FormControl className={classes.formUser}>
                    <FormLabel style={{color: "red"}}>{"Please provide the description."}</FormLabel>
                </FormControl>
            }
        </DialogContent>
        <DialogActions>
            <Button 
                onClick={()=> {
                    setOpenRequestForm(false);
                    setDescription("");
                    setIsErrorResp(false);
                }} 
                color="primary"
            >
                {"Cancel"}
            </Button>
            <Button 
                onClick={async()=> {
                    if (description == "") {
                        setIsErrorResp(true);
                        return;
                    }
                    setIsApiKeyRequesting(true)
                    await requestApiKey();
                    setIsApiKeyRequesting(false);
                }} 
                color="primary" 
                autoFocus
            >
                Request {isApiKeyRequesting && <CircularProgress style={{width: 15, height: 15, marginLeft: 5}} />}
            </Button>
        </DialogActions>
    </Dialog>

    <Dialog
        open={oneTimeViewAPIKey}
        maxWidth={"xs"}
        onClose={()=> {
            setOneTimeViewAPIKey(null);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <DialogTitle id="alert-dialog-title">{"Your Api key"}</DialogTitle>
        <DialogContent>
            <DialogContentText>
                {"Please save this api key safe and accessible. You won't be able to view it again in Tigersheet. If you lose this api key, you can request for a new one."}
            </DialogContentText>
            <FormControl className={classes.formApiKey}>
                <TextField
                    autoFocus
                    fullWidth
                    margin="dense"
                    id="name"
                    value={oneTimeViewAPIKey}
                    variant={"outlined"}
                />
            </FormControl>
            <FormControl>
                <IconButton 
                    style={{marginLeft: 5}} 
                    aria-label="close" 
                    className={classes.closeButton}
                    onClick={()=>{
                        navigator.clipboard.writeText(oneTimeViewAPIKey);
                        window.appStore.notificationStore.showNotification(
                            "Api key copied successfully",
                            "success"
                        );
                    }}
                >
                    <FileCopyIcon style={{color: "#237ff4"}}/>
                </IconButton>
            </FormControl>
        </DialogContent>
        <DialogActions>
            <Button 
                onClick={()=> {
                    setOneTimeViewAPIKey(null);
                }} 
                color="primary"
            >
                {"Close"}
            </Button>
        </DialogActions>
    </Dialog>
    </>
  );
}

export default observer(ApiKeys);
